import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { pagePreviews } from '../../data/pagePreviews';
import { SectionLabel } from '../ui/SectionLabel';
export function PagePreviews() {
  const [index, setIndex] = useState(0);
  const total = pagePreviews.length;
  const current = pagePreviews[index];
  const goTo = (next: number) => setIndex((next + total) % total);
  return <section aria-labelledby="paginas-title" className="w-full bg-ink-850" data-id="element-153" data-mp="2uj8q6dnu7ihx">
      <div className="mx-auto max-w-4xl px-5 py-16 md:py-20" data-id="element-154" data-mp="2yln5wow7m24z">
        <div className="mx-auto max-w-2xl text-center" data-id="element-155" data-mp="2yjskzakxua0w">
          <SectionLabel data-id="element-156" data-mp="2kn5plc8mvrx3">Así se ve por dentro</SectionLabel>
          <h2 id="paginas-title" className="mt-5 font-display text-3xl font-black leading-tight text-white md:text-4xl" data-id="element-157" data-mp="2pl773sqevj6g">
            Páginas reales del método
          </h2>
          <p className="mt-4 text-base leading-relaxed text-body" data-id="element-158" data-mp="ntlqvg7yye1b">
            Checklists, tablas y guiones listos para usar. Pasa las páginas una por una y mira el
            nivel de detalle antes de comprar.
          </p>
        </div>

        <div className="mt-10" role="group" aria-roledescription="carrusel" aria-label="Páginas del método" onKeyDown={event => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(index - 1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goTo(index + 1);
        }
      }} data-id="element-159" data-mp="2t446stxhot4r">
          <div className="flex items-center gap-3 md:gap-5" data-id="element-160" data-mp="2o5kkutiwbhce">
            <button type="button" onClick={() => goTo(index - 1)} aria-label="Página anterior" className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-ink-border bg-ink-card text-white transition-colors duration-150 ease-out hover:border-brand-green hover:text-brand-green focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-green" data-id="element-161" data-mp="2o7432po442gt">
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-162" data-mp="2x6093g16ybv3" />
            </button>

            <figure className="min-w-0 flex-1" data-id="element-163" data-mp="319ognyptp7gc">
              <div className="mx-auto w-full max-w-sm overflow-hidden rounded-xl border border-ink-border bg-white shadow-panel" data-id="element-164" data-mp="367zqi9g4bhyk">
                <img key={current.src} src={current.src} alt={current.alt} loading="lazy" className="aspect-[1/1.414] w-full object-contain" data-id="element-165" data-mp="29j0hutbmge5u" />
              </div>
              <figcaption className="mx-auto mt-5 max-w-md text-center text-sm leading-relaxed text-body" data-id="element-166" data-mp="2n93xh1fzx9mb">
                <span className="mb-2 block text-xs font-bold uppercase tracking-[0.14em] text-subtle" aria-live="polite" data-id="element-167" data-mp="1pujceqa1n0um">
                  Página {index + 1} de {total}
                </span>
                {current.caption}
              </figcaption>
            </figure>

            <button type="button" onClick={() => goTo(index + 1)} aria-label="Página siguiente" className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-ink-border bg-ink-card text-white transition-colors duration-150 ease-out hover:border-brand-green hover:text-brand-green focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-green" data-id="element-168" data-mp="1ibidkia6tvdl">
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-169" data-mp="ulxvs2prt45w" />
            </button>
          </div>

          <ul className="mt-7 flex flex-wrap items-center justify-center gap-2.5" data-id="element-170" data-mp="pn4gq5uu553m">
            {pagePreviews.map((page, pageIndex) => <li key={page.src} data-id="element-171" data-mp="lm121moixf3z" data-mpi={pageIndex}>
                <button type="button" onClick={() => setIndex(pageIndex)} aria-label={`Ver página ${pageIndex + 1}`} aria-current={pageIndex === index ? 'true' : undefined} className={`h-2.5 rounded-full transition-colors duration-150 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-green ${pageIndex === index ? 'w-7 bg-brand-green' : 'w-2.5 bg-ink-border hover:bg-subtle'}`} data-id="element-172" data-mp="gklijz1zvgnp" />
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}